<template>
  <div style="height: 100%">
    <div class="hello" ref="pie_chartdiv" style="min-height: 150px"></div>
    <div :id="'pie_legend_id_' + legend_id" class="pie-legend"></div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
export default {
  name: "pieChart",
  props: {
    chart_data: {
      type: Array,
      require: true,
      default: () => {
        return {};
      },
    },
    legend_id: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    chart_data: function (val) {
      this.pie_chart_setting(val);
    },
  },
  data: () => ({
    color_list: ["#4cda64", "#f3dd68", "#ffa32b", "#52d5ff", "#52ffdc", "#cee8ff", "#e3d8d8"],
  }),
  mounted() {
    this.pie_chart_setting(this.chart_data);
  },
  methods: {
    pie_chart_setting(val) {
      let chart = am4core.create(this.$refs.pie_chartdiv, am4charts.PieChart);
      chart.data = val;
      // Add and configure Series

      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "countCategory";
      pieSeries.dataFields.category = "categorySubject";
      pieSeries.colors.step = 3;

      chart.innerRadius = am4core.percent(70);

      let me = this;
      chart.events.on("ready", function (event) {
        chart.customLegend = document.getElementById("pie_legend_id_" + me.legend_id);
        pieSeries.dataItems.each(function (row, i) {
          chart.customLegend.innerHTML +=
            '<div class="legend-item" id="legend-item-' +
            i +
            '" onclick="toggleSlice(' +
            i +
            ');" onmouseover="hoverSlice(' +
            i +
            ');" onmouseout="blurSlice(' +
            i +
            ');" ><div class="legend-marker" style="background: ' +
            me.color_list[i] +
            '"></div>' +
            row.category +
            " " +
            row.values.value.percent.toFixed(1) +
            "%" +
            "</div>";
        });
      });

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      var colorSet = new am4core.ColorSet();
      colorSet.list = ["#4cda64", "#f3dd68", "#ffa32b", "#52d5ff", "#52ffdc", "#cee8ff", "#e3d8d8"].map(function (color) {
        return new am4core.color(color);
      });
      pieSeries.colors = colorSet;
    },
  },
};
</script>
